var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auto-menu-layout',[_c('no-duplicates')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }